<template>
  <div>
    <SweetModal
      ref="modalRef"
      :hide-close-button="true"
      class="template-tags-modal"
    >
      <Loading :active="savingTemplate" :is-full-page="false" />

      <Multiselect
        v-model="selectedTags"
        :options="availableTags"
        :multiple="true"
        :taggable="true"
        :max="3"
        :placeholder="$t('tags.add_tags')"
        :selectLabel="$t('tags.select_label')"
        :selectedLabel="$t('tags.selected_label')"
        :deselectLabel="$t('tags.deselect_label')"
        :tag-placeholder="$t('tags.create_tag')"
        @tag="addTag"
        @search-change="filterTags"
      >
        <template #maxElements>
          {{ $t('tags.max_message') }}
        </template>
        <template #noOptions>
          {{ $t('tags.no_options') }}
        </template>
      </Multiselect>

      <h5 v-if="invalidTag" class="danger">{{ $t('tags.invalid_tag_msg') }}</h5>
      <h5 class="text-muted">{{ $t('tags.template_tags_limitation_msg') }}</h5>

      <div class="modal-footer">
        <button class="btn btn-default right-margin" @click="close">
          {{ $t('modals.close_button') }}
        </button>
        <button class="btn btn-primary" @click="save">
          {{ $t('modals.save_button') }}
        </button>
      </div>
    </SweetModal>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import Loading from 'vue-loading-overlay';
import Multiselect from 'vue-multiselect';
import {union} from 'lodash';

export default {
  name: 'TemplateTagsModal',
  components: {
    SweetModal,
    Loading,
    Multiselect
  },
  data() {
    return {
      selectedTags: [],
      availableTags: [],
      invalidTag: false,
      template: null
    };
  },
  computed: {
    ...mapState({
      success: state => state.success,
      conflict: state => state.conflict,
      customerTags: state => state.customerTags,
      savingTemplate: state => state.savingTemplate
    })
  },
  methods: {
    ...mapMutations(['setSuccess']),
    ...mapActions(['getTags', 'saveTemplateTags', 'saveTags']),
    open(t) {
      this.template = t;
      this.availableTags = [...this.customerTags];
      this.selectedTags = t.tags ? [...t.tags] : [];
      this.invalidTag = false;

      this.setSuccess(false);
      this.$refs.modalRef.open();
    },
    close() {
      this.$refs.modalRef.close();
    },
    save() {
      const allTags = union(this.selectedTags, this.customerTags);

      if (allTags.length > this.customerTags.length) {
        const payload = {tags: allTags, updateStatus: false};
        this.saveTags(payload);
      }

      const updatedTemplate = {...this.template};
      updatedTemplate.tags = this.selectedTags;

      this.saveTemplateTags(updatedTemplate);
    },
    addTag(newTag) {
      const regex = /^[\w-]+$/;
      if (newTag.length > 10 || !regex.test(newTag)) {
        this.invalidTag = true;
        return;
      }
      this.invalidTag = false;

      if (!this.availableTags.includes(newTag)) {
        this.availableTags.push(newTag);
      }
      if (!this.selectedTags.includes(newTag)) {
        this.selectedTags.push(newTag);
      }
    },
    filterTags(query) {
      if (!query) {
        this.availableTags = [...this.customerTags];
      } else {
        this.availableTags = this.customerTags.filter(tag =>
          tag.toLowerCase().startsWith(query.toLowerCase())
        );
      }
    }
  },
  watch: {
    success(newVal) {
      if (newVal === true) {
        this.close();
      }
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}

h5.danger {
  color: rgb(217, 83, 79);
}

.modal-main-content {
  flex-grow: 1;
  overflow-y: auto;
}

.template-tags-modal .sweet-content {
  position: relative;
  padding: 1rem;
  padding-bottom: 50px;
  min-height: 300px;
  box-sizing: border-box;
}

.modal-footer {
  position: absolute;
  bottom: 8px;
  right: 0;
  width: 100%;
  border-top: 1px solid #e5e5e5;
  padding: 0.75rem 1rem 0 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  background: white;
  box-sizing: border-box;
}

@import 'vue-multiselect/dist/vue-multiselect.min.css';
</style>
